module.exports = __webpack_public_path__ + "static/media/right-arrow.c04995ee.svg";